import {createFileRoute} from '@tanstack/react-router';

import {NewClientPage} from '@/modules/clients/pages/NewClientPage';

export const Route = createFileRoute('/_authenticated/clients/new')({
  component: NewClientPage,
});
